/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div[_ngcontent-%COMP%]{float:right;margin:-8px -12px 0 5px}div[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{background-color:#ff720a;-webkit-clip-path:circle(50% at 50% 50%);clip-path:circle(40% at 50% 50%);padding:6px;font-size:10px;font-weight:700;color:#fff}"];
export { styles as styles };
